var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "image-display" } }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col" }, [
        _c("img", {
          staticClass: "img-thumbnail",
          staticStyle: { width: "500px" },
          attrs: { src: _vm.imgSrc }
        })
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row pt-1" }, [
      _c("div", { staticClass: "col" }, [_vm._v(_vm._s(_vm.caption))]),
      _vm._v(" "),
      _c("div", { staticClass: "col-auto" }, [
        _vm.popoverContent
          ? _c(
              "a",
              {
                attrs: {
                  href: "#",
                  onclick: "return false;",
                  tabindex: "0",
                  "data-toggle": "popover",
                  "data-trigger": "focus",
                  title: "Info",
                  "data-content": _vm.popoverContent
                }
              },
              [_vm._v("Info")]
            )
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }